import { Box } from '@zoopla-eng/zds-components/box';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import { PICTOGRAMS_REMOTE_SPRITE_URL } from '@zoopla/assets';
import {
    PageSubtitleShort,
    SectionSubtitle
} from '@zoopla-eng/zds-components/headings';
import {
    customStackStyle,
    valuePropStyle,
    pictogramWrapperStyle
} from './value-propositions.styles.css';
import { getPictogram } from './pictogram';
import { ValuePropCollection } from './types';

export type ValuePropositionCollectionProps = {
    data: ValuePropCollection;
};

export const ValuePropositionCollection = ({
    data
}: ValuePropositionCollectionProps) => (
    <Box fw display="flex" flexDirection="column" rowGap="S500">
        <PageSubtitleShort>{data.title}</PageSubtitleShort>

        <div className={customStackStyle}>
            {data.reasonsToUse?.map((vp, i) => {
                const Pictogram = getPictogram(vp?.pictogram ?? '');
                return (
                    <div className={valuePropStyle} key={i}>
                        {Pictogram && (
                            <div className={pictogramWrapperStyle}>
                                <Pictogram
                                    remoteSpriteUrl={
                                        PICTOGRAMS_REMOTE_SPRITE_URL
                                    }
                                />
                            </div>
                        )}
                        <SectionSubtitle>{vp?.title}</SectionSubtitle>
                        <p className={fontGroups.ladle}>{vp?.description}</p>
                    </div>
                );
            })}
        </div>
    </Box>
);
